import React from 'react'
import { DepartmentConsumer } from '#src/context/department'
import { HostnameConsumer, Hostname } from '#src/containers/Hostname'
import { UserAgentConsumer } from '#src/containers/UserAgent'
import useReactRouter from 'use-react-router'
import { NavLink } from 'react-router-dom'
import { isConsumerMobileNative } from '#src/services/mobile'
import DepartmentIcon from '#src/components/DepartmentIcon'
import ChevronLeftIcon from './chevron-left.svg'
import BrandAwareLogo from '#src/components/Logo'
import GradientMask from './gradient-mask.svg'
import styles from './styles.css'

interface LogoProps {
  transparent?: boolean
}

const Logo: React.SFC<LogoProps> = ({ transparent }) => {
  const { history } = useReactRouter()
  return (
    <UserAgentConsumer>
      {userAgent => {
        return (
          <HostnameConsumer>
            {hostname => {
              return (
                <DepartmentConsumer>
                  {({ department }) => {
                    return (
                      <>
                        <GradientMask className={styles.departmentIconGradient} />

                        <NavLink
                          to={department ? `/d/${department.slug}` : '/'}
                          className={styles.link}
                        >
                          {/* Must stop event propagation if back button is clicked to avoid NavLink interference */}
                          {isConsumerMobileNative(userAgent) ? (
                            <div className={styles.backButtonWrapper}>
                              <ChevronLeftIcon
                                onClick={e => {
                                  history.goBack()
                                  e.stopPropagation()
                                }}
                                className={styles.backButton}
                              />
                            </div>
                          ) : (
                            <DepartmentIcon
                              departmentType={department && department.type}
                              useFallback={hostname === Hostname.Curated}
                              className={styles.departmentIcon}
                            />
                          )}

                          <div className={styles.stack}>
                            <BrandAwareLogo
                              color={transparent ? 'light' : 'dark'}
                              className={styles.wordmark}
                            />
                            {department && (
                              <div className={styles.departmentName}>{department.displayName}</div>
                            )}
                          </div>
                        </NavLink>
                      </>
                    )
                  }}
                </DepartmentConsumer>
              )
            }}
          </HostnameConsumer>
        )
      }}
    </UserAgentConsumer>
  )
}

export default Logo
